import React, {useState, useEffect, useRef} from "react";
import { GoBackButton, HeaderContainer, Link, ProfileButton, SearchContainer } from "./style";

import { BiChevronLeft } from "react-icons/bi";
import { BiUser } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import AuthService from "../../../AuthService";
import InputWithAbortController from "./input";
export default function Header() {
    const [searchResults, setSearchResults] = useState({});
    const [searchFocus, setSearchFocus] = useState(false);
    const searchContainerRef = useRef(null);
    const navigate = useNavigate();

    const {tab} = useParams();

    useEffect(() => {
        function handleClickOutside(event) {
            if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
                setSearchFocus(false);
                document.body.style.overflow = 'auto';
            }
        }

        if (searchFocus) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [searchFocus]);
    const searchProducts = async (searchTerm, signal) => {
        return fetch(`https://api.rb.beeapp.es/admin/search?s=${searchTerm}`, {
            signal: signal,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
        })
            .then(response => response.json())
            .then(data => {
                setSearchResults(data);
            });

        }

    const goToSearchResults = (searchTerm) => {
        const cleanSearch = (searchTerm || '').trim();
        if (!cleanSearch) return;
        setSearchFocus(false);
        document.body.style.overflow = 'auto';
        navigate(`/admin/search?s=${encodeURIComponent(cleanSearch)}`);
    };

    
    
    return (
        <HeaderContainer>
            <GoBackButton
                onClick={() => window.location.href = '/'}
            >
                <BiChevronLeft size={24} color="#026E1F" />
                
            </GoBackButton>
            <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0px',
                marginRight: 'auto',
                marginLeft: '10px',
            }}
            >
            <Link href="/admin" active={tab === '' || tab === null || tab === undefined} >
                Productos
            </Link>

            <Link href="/admin/users" active={tab === 'users'} >
                Usuarios
            </Link>

            <Link href="/admin/sells" active={tab === 'sells'}>
                Ventas
            </Link>
            <Link href="/admin/carts" active={tab === 'carts'}>
                Carritos
            </Link>
            <Link href="/admin/home-editor" active={tab === 'home-editor'}>
                Home
            </Link>
            </div>

            <div style={{ position: 'relative' }} ref={searchContainerRef}>
                <SearchContainer
                    searchFocus={searchFocus}
                >
                    <InputWithAbortController
                        onSearch={searchProducts}
                        onFocus={() => {
                            setSearchFocus(true);
                        }}
                        onEnter={goToSearchResults}
                    />
                </SearchContainer>

                <div style={{
                    width: '400px',
                    height: 'auto',
                    maxHeight: '500px',
                    position: 'absolute',
                    top: 'calc(100% + 2px)',
                    left: '0',
                    backgroundColor: '#fff',
                    zIndex: '1000',
                    display: searchFocus ? 'block' : 'none',
                    overflow: 'auto',
                    boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                }}>
                    <div style={{
                        display: 'flex',
                        padding: '12px 16px 8px 16px',
                        backgroundColor: '#fff',
                        fontSize: '0.875rem',
                        gap: '6px',
                        alignItems: 'center',
                        fontWeight: '600',
                        color: '#1f2937',
                    }}>
                        Productos
                        <span style={{
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            color: '#6b7280',
                            backgroundColor: '#f3f4f6',
                            padding: '2px 8px',
                            borderRadius: '10px',
                        }}>
                            {searchResults?.products?.totalSearchedProducts || 0} resultados
                        </span>

                        <span style={{
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            color: '#028322',
                            marginLeft: 'auto',
                            cursor: 'pointer',
                        }}
                            onClick={() => goToSearchResults(localStorage.getItem('search'))}
                        >
                            Ver todos
                        </span>
                    </div>
                    {
                        searchResults?.products?.productsSearch?.length !== 0 && searchResults?.products?.productsSearch?.map((product, index) => {
                            return (
                                <div key={index} style={{
                                    display: 'flex',
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    alignItems: 'center',
                                    gap: '10px',
                                    borderTop: '1px solid #f3f4f6',
                                    transition: 'background-color 0.15s',
                                }}
                                    onClick={() => {
                                        window.location.href = '/admin/product-edit/' + product._id;
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                >
                                    <img src={product.images[0]} alt={product.name} style={{
                                        width: '40px',
                                        height: '40px',
                                        objectFit: 'cover',
                                        borderRadius: '4px',
                                        flexShrink: 0,
                                    }}/>
                                    <span style={{
                                        fontSize: '0.8125rem',
                                        color: '#374151',
                                        fontWeight: '400',
                                    }}>
                                        {product.name}
                                    </span>
                                </div>
                            )
                        })
                    }
                    <div style={{
                        display: 'flex',
                        padding: '12px 16px 8px 16px',
                        backgroundColor: '#fff',
                        fontSize: '0.875rem',
                        gap: '6px',
                        alignItems: 'center',
                        fontWeight: '600',
                        color: '#1f2937',
                        borderTop: '2px solid #f3f4f6',
                        marginTop: '4px',
                    }}>
                        Usuarios
                        <span style={{
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            color: '#6b7280',
                            backgroundColor: '#f3f4f6',
                            padding: '2px 8px',
                            borderRadius: '10px',
                        }}>
                            {searchResults?.users?.totalSearchedUsers || 0} resultados
                        </span>

                        <span style={{
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            color: '#028322',
                            marginLeft: 'auto',
                            cursor: 'pointer',
                        }}>
                            Ver todos
                        </span>
                    </div>
                    {
                        searchResults?.users?.usersSearch?.length !== 0 && searchResults?.users?.usersSearch?.map((user, index) => {
                            return (
                                <div key={index} style={{
                                    display: 'flex',
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    alignItems: 'center',
                                    gap: '10px',
                                    borderTop: '1px solid #f3f4f6',
                                    transition: 'background-color 0.15s',
                                }}
                                    onClick={() => {
                                        window.location.href = '/admin/user-edit/' + user._id;
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                >
                                    <BiUser size={24} color="#9ca3af" style={{ flexShrink: 0 }} />
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}>
                                        <span style={{
                                            fontSize: '0.8125rem',
                                            color: '#374151',
                                            fontWeight: '500',
                                        }}>
                                            {user.Name} {user.Surname}
                                        </span>
                                        <span style={{
                                            fontSize: '0.75rem',
                                            color: '#6b7280',
                                        }}>
                                            ({user.Email})
                                        </span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            <ProfileButton>
                <BiUser size={24} color="#fff" />
            </ProfileButton>
        </HeaderContainer>
        )
    }
